import { createSaga } from './saga-helpers';

import * as Api from '../api/templates-api';

const watchGetTemplates = createSaga({
    type: 'TEMPLATES_FETCH',
    fn: Api.fetchTemplates,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        templates: items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateTemplate = createSaga({
    type: 'TEMPLATE_CREATE',
    fn: Api.createTemplate,
    args: action => [action.payload.template],
    successPayload: ({ id: templateId }, action) => ({
        templateId,
        fragment: action.payload.template
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.template
    })
});

const watchGetTemplate = createSaga({
    type: 'TEMPLATE_FETCH',
    fn: Api.fetchTemplate,
    args: action => [action.payload.templateId],
    successPayload: template => ({ template })
});

const watchUpdateTemplate = createSaga({
    type: 'TEMPLATE_UPDATE',
    fn: Api.updateTemplate,
    args: action => [action.payload.templateId, action.payload.templateProps],
    successPayload: template => ({ template })
});

const watchRemoveTemplate = createSaga({
    type: 'TEMPLATE_REMOVE',
    fn: Api.removeTemplate,
    args: action => [action.payload.templateId]
});

const sagas = [watchGetTemplates, watchCreateTemplate, watchGetTemplate, watchUpdateTemplate, watchRemoveTemplate];

export default sagas;
